import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import bgVideo from "../assets/lbg.mp4";

export default function NotificationCenter() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unreadEstimate, setUnreadEstimate] = useState(0);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/notifications");
      setItems(Array.isArray(res.data?.items) ? res.data.items : []);
      setUnreadEstimate(Number(res.data?.unread_estimate || 0));
    } catch (error) {
      console.error(error);
      setItems([]);
      setUnreadEstimate(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const statusClass = (status) => {
    if (status === "approved" || status === "Resolved") {
      return "border-teal-300/40 bg-teal-500/15 text-teal-200";
    }
    if (status === "rejected" || status === "overdue") {
      return "border-red-300/40 bg-red-500/15 text-red-200";
    }
    if (status === "needs_clarification" || status === "due_soon") {
      return "border-amber-300/40 bg-amber-500/15 text-amber-200";
    }
    return "border-white/20 bg-white/5 text-slate-300";
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-slate-950 font-sans text-white">
      <div className="absolute inset-0">
        <video data-workspace-background="true" aria-hidden="true" src={bgVideo} autoPlay muted loop playsInline className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-950/85" />
      </div>

      <div className="workspace-page-body relative z-10 min-h-screen px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-col gap-4 border-b border-white/10 pb-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.35em] text-teal-300">
              Workflow Activity
            </p>
            <h1 className="mt-2 text-3xl font-bold tracking-wide md:text-4xl">Action Logs</h1>
            <p className="mt-2 max-w-2xl text-sm text-slate-300 md:text-base">
              Recent workflow updates for payments, reports, and announcements.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="rounded-lg border border-teal-300/40 bg-teal-500/10 px-3 py-2 text-sm font-semibold text-teal-200">
              {unreadEstimate} recent
            </span>
            <button
              onClick={load}
              className="rounded-lg border border-white/15 px-4 py-2 text-sm font-semibold text-slate-100 transition hover:bg-white/10"
            >
              Refresh
            </button>
          </div>
        </div>

        {loading ? (
          <div className="rounded-lg border border-white/10 bg-slate-950/90 py-10 text-center text-slate-300">
            Loading action logs...
          </div>
        ) : items.length === 0 ? (
          <div className="rounded-lg border border-dashed border-white/15 bg-slate-950/70 py-10 text-center text-slate-300">
            No action logs yet.
          </div>
        ) : (
          <div className="grid gap-3">
            {items.map((item) => (
              <article key={item.id} className="rounded-lg border border-white/10 bg-slate-950/90 p-4 shadow-xl">
                <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                  <div>
                    <p className="text-sm font-semibold text-white">{item.title}</p>
                    <p className="mt-1 text-sm text-slate-300">{item.message}</p>
                    <p className="mt-1 text-xs text-slate-500">
                      {item.created_at ? new Date(item.created_at).toLocaleString() : "-"}
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    {item.status && (
                      <span
                        className={`inline-flex rounded-full border px-3 py-1 text-xs font-semibold ${statusClass(
                          item.status
                        )}`}
                      >
                        {String(item.status).replaceAll("_", " ")}
                      </span>
                    )}
                    <button
                      onClick={() => navigate(item.route || "/")}
                      className="rounded-lg bg-teal-600 px-3 py-2 text-sm font-semibold text-white transition hover:bg-teal-500"
                    >
                      Open
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

